(ns ui.view.transaction-process.components.header-menu
  (:require
   [common.localization :refer [tr]]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.components.modal.view :as modal]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]))

(defn- confirm-delete-modal
  [{:keys [on-confirm on-cancel]}]
  [modal/view
   {:visible? true
    :hide!    on-cancel}
   (tr :transaction-process/delete-transaction)
   [:p {:class "text-sm m-0 text-gray-600"}
    (tr :transaction-process/delete-confirm)]
   [modal/footer-children-left-and-right
    [[button/secondary-hollow
      {:on-click on-cancel}
      (tr :cancel)]]
    [[button/danger-solid
      {:on-click on-confirm}
      (tr :delete)]]]])

(defn view
  [_props]
  (let [confirming? (r/atom false)]
    (fn [{:keys [on-permissions on-delete on-audit-trail on-print on-view-details on-toggle-favorite favorite? read-only?]}]
      [:<>
       [dropdown-menu/view
        {:items (cond-> [{:key        "favorite"
                          :icon-class "fal fa-star"
                          :label      (tr (if favorite?
                                            :unflag-entity-menu-item
                                            :flag-entity-menu-item))
                          :on-click   (fn [] (when on-toggle-favorite (on-toggle-favorite)))}
                         {:key        "audit-trail"
                          :icon-class "fal fa-history"
                          :label      (tr :audit-trail)
                          :on-click   (fn [] (when on-audit-trail (on-audit-trail)))}
                         {:key        "view-details"
                          :icon-class "fal fa-eye"
                          :label      (tr :transaction-process/see-all-details)
                          :on-click   (fn [] (when on-view-details (on-view-details)))}
                         {:key        "print"
                          :icon-class "fal fa-download"
                          :label      (tr :download-pdf)
                          :on-click   (fn [] (when on-print (on-print)))}
                         {:key "sep-1" :separator? true}
                         {:key        "permissions"
                          :icon-class "fal fa-lock"
                          :label      (tr :permissions)
                          :on-click   (fn [] (when on-permissions (on-permissions)))}]
                  (not read-only?)
                  (into [{:key "sep-2" :separator? true}
                         {:key        "delete"
                          :icon-class "fal fa-trash"
                          :label      (tr :delete)
                          :on-click   (fn [] (reset! confirming? true))}]))
         :props {:hide-arrow? true
                 :align       :end}
         :trigger-as-child
         [:span
          [:button
           {:class "w-8 h-8 flex items-center justify-center rounded hover:bg-gray-100 text-gray-500"}
           [:i
            {:class "fas fa-ellipsis-v text-md m-0"}]]]}]
       (when @confirming?
         [confirm-delete-modal
          {:on-confirm (fn []
                         (reset! confirming? false)
                         (when on-delete (on-delete)))
           :on-cancel  (fn []
                         (reset! confirming? false))}])])))
